export default __webpack_public_path__ + "static/media/SquareBlue.8ff55bb9.svg";